export const testimonialList = [
    {
        review: "Andy has tutored my son since GCSE and helped him secure a place at Cambridge University to study maths (GCSE - grade 9, 'A' level maths - A*, 'A' level further maths - A*, STEP 2 - grade 1, STEP 3 - grade 1). If you're looking for an exceptional tutor, look no further!",
        reviewer: "Olya Fialko"
    },
    {
        review: "Fantastic tuition, friendly and helpful. Helped me achieve A*/A at maths and further maths ensuring I secured a place at London School of Economics. Would recommend to anyone wanting an excellent maths tutor.",
        reviewer: "Kiera Glendenning"
    },
    {
        review: "Andy was brilliant, helping me achieve an A* in HNC maths (with scores of 91%, 93% and 81%), a subject I struggled with. Andy is very friendly and patient, I strongly recommend.",
        reviewer: "Sam Dobson"
    },
    {
        review: "Under Andy's tutelage my son achieved a grade 9 GCSE, A in GCSE statistics and A* in maths and further maths, securing a place at Durham University to study maths.",
        reviewer: "Helen Gavin"
    },
    {
        review: "Andy has tutored my son for the past 2 years and with his help he achieved an A* in both 'A' level maths and further maths, helping to secure a place at University College London.",
        reviewer: "Banu Patil"
    },
    {
        review: "Andy has been excellent this year with tutoring my daughter in 'A' level maths, managed to improve her results in two papers by 5 grades. Always punctual, reliable, supportive and provided lots of extra homework material. Would definitely recommend, thank you!",
        reviewer: "Trina Ryan"
    }
];
